// localStorage key name could be different due to a backward compability
// removed CSRF from interface to prevent from confussion
export interface InstallationsAnnouncementStorageValues {
  token: string;
  hidePermanently: string;
  temporarilyHideForToken: string;
}

export const hideInstallationsAnnouncementBannerKey = 'hideInstallationsAnnouncementBanner';
export const temporarilyHideInstallationsAnnouncementBanner =
  'temporarilyHideInstallationsAnnouncementBanner';

export enum BookingSubscriptionPackageOptions {
  Normal,
  Commercial,
  FlatRate,
  UserUsaCanada,
}

export interface CallbackHoursOptions {
  callbackMondayHours?: string;
  callbackTuesdayHours?: string;
  callbackWednesdayHours?: string;
  callbackThursdayHours?: string;
  callbackFridayHours?: string;
  callbackSaturdayHours?: string;
  callbackSundayHours?: string;
}
